// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataContentColumn {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.compactData {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 85%;
    height: 85%;
    gap: 5px;
    min-width: 0;
}

.InfoData {
    /* border-color: #088eee; */

    width: 100%;
    height: 60%;
    border-top: none;
    border-left: none;
    border-radius: var(--border-radios-small);
    background-color: transparent;
    font-size: var(--font-size-small);
    min-width: 0;

    /* letter-spacing: 1px; */
    text-align: center;
    top: 0%;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
}

.labelData {
    /* font-weight: bold; */
    position: relative;
    top: 0%;
    font-size: x-large;
    /* color: #088eee; */
    text-align: center;
    white-space: normal;

    line-height: 1.1;
}

.inpUP {
    border-color: var(--green);
    color: var(--green);
}

.lblUP {
    color: var(--green);
}

.lblEXCEP {
    color: #46041f;
    z-index: 3;
}

.inpEXCEP {
    border-color: #ee0808;
    background-color: #330015c9;
    color: #ffffff;
    cursor: pointer;
}

.inpDOWN {
    border-color: #ee0808;
    color: #ee0808;
}

.inpDOWND {
    border-color: rgb(240, 0, 191);
    color: rgb(240, 0, 191);
}

.lblDOWN {
    color: #ee0808;
}

.lblDOWND {
    color: rgb(240, 0, 191);
}

.inpDOWN4 {
    border-color: #ee5c08;
    color: #ee5c08;
}

.lblDOWN4 {
    color: #ee5c08;
}

.inpDOWN3 {
    border-color: #ee9d08;
    color: #ee9d08;
}

.lblDOWN3 {
    color: #ee9d08;
}

.inpDOWN2 {
    border-color: var(--yellow);
    color: var(--yellow);
}

.lblDOWN2 {
    color: var(--yellow);
}

.inpDOWN1 {
    border-color: var(--s1);
    color: var(--s1);
}

.lblDOWN1 {
    color: var(--s1);
}

/**********************************************/
.exceptionCell .inpCFE {
    border-color: #02500b;
    background-color: #00da19b7;
    color: #ffffff;
    height: 100%;
    top: 0%;
}

.exceptionCell .lblCFE {
    color: #ffffff;
    top: 10%;
    left: 5%;
    z-index: 2;
    font-weight: bold;
}

.exceptionCell .inpCONAGUA {

    border-color: #002a33;
    background-color: #00b7e1;
    color: #ffffff;
    height: 100%;
    top: 0%;
}

.exceptionCell .lblCONAGUA {
    color: #ffffff;
    top: 10%;
    left: 5%;
    z-index: 2;
    font-weight: bold;
}

.exceptionCell input {
    border-color: #330015;
    background-color: #9e0143;
    color: #fdfdfd;
    height: 100%;
    top: 0%;
}

.exceptionCell label {
    color: #ffffff;
    top: 10%;
    left: 5%;
    z-index: 2;
    /* font-weight: bold; */
    word-break: break-all;
    word-wrap: anywhere;
    white-space: wrap;
}


/************************Horizontal Movil*************************/
@media (min-width: 500px) and (max-width: 900px) {}

/************************Movil*************************/
@media (max-width: 500px) {
    .labelData {
        font-size: var(--font-size-small) !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/InfoStatus.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,2BAA2B;;IAE3B,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,6BAA6B;IAC7B,iCAAiC;IACjC,YAAY;;IAEZ,yBAAyB;IACzB,kBAAkB;IAClB,OAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;;AAGA,kEAAkE;AAClE,kDAAkD;;AAElD,uDAAuD;AACvD;IACI;QACI,4CAA4C;IAChD;AACJ","sourcesContent":[".dataContentColumn {\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.compactData {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 85%;\r\n    height: 85%;\r\n    gap: 5px;\r\n    min-width: 0;\r\n}\r\n\r\n.InfoData {\r\n    /* border-color: #088eee; */\r\n\r\n    width: 100%;\r\n    height: 60%;\r\n    border-top: none;\r\n    border-left: none;\r\n    border-radius: var(--border-radios-small);\r\n    background-color: transparent;\r\n    font-size: var(--font-size-small);\r\n    min-width: 0;\r\n\r\n    /* letter-spacing: 1px; */\r\n    text-align: center;\r\n    top: 0%;\r\n    position: relative;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.labelData {\r\n    /* font-weight: bold; */\r\n    position: relative;\r\n    top: 0%;\r\n    font-size: x-large;\r\n    /* color: #088eee; */\r\n    text-align: center;\r\n    white-space: normal;\r\n\r\n    line-height: 1.1;\r\n}\r\n\r\n.inpUP {\r\n    border-color: var(--green);\r\n    color: var(--green);\r\n}\r\n\r\n.lblUP {\r\n    color: var(--green);\r\n}\r\n\r\n.lblEXCEP {\r\n    color: #46041f;\r\n    z-index: 3;\r\n}\r\n\r\n.inpEXCEP {\r\n    border-color: #ee0808;\r\n    background-color: #330015c9;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n}\r\n\r\n.inpDOWN {\r\n    border-color: #ee0808;\r\n    color: #ee0808;\r\n}\r\n\r\n.inpDOWND {\r\n    border-color: rgb(240, 0, 191);\r\n    color: rgb(240, 0, 191);\r\n}\r\n\r\n.lblDOWN {\r\n    color: #ee0808;\r\n}\r\n\r\n.lblDOWND {\r\n    color: rgb(240, 0, 191);\r\n}\r\n\r\n.inpDOWN4 {\r\n    border-color: #ee5c08;\r\n    color: #ee5c08;\r\n}\r\n\r\n.lblDOWN4 {\r\n    color: #ee5c08;\r\n}\r\n\r\n.inpDOWN3 {\r\n    border-color: #ee9d08;\r\n    color: #ee9d08;\r\n}\r\n\r\n.lblDOWN3 {\r\n    color: #ee9d08;\r\n}\r\n\r\n.inpDOWN2 {\r\n    border-color: var(--yellow);\r\n    color: var(--yellow);\r\n}\r\n\r\n.lblDOWN2 {\r\n    color: var(--yellow);\r\n}\r\n\r\n.inpDOWN1 {\r\n    border-color: var(--s1);\r\n    color: var(--s1);\r\n}\r\n\r\n.lblDOWN1 {\r\n    color: var(--s1);\r\n}\r\n\r\n/**********************************************/\r\n.exceptionCell .inpCFE {\r\n    border-color: #02500b;\r\n    background-color: #00da19b7;\r\n    color: #ffffff;\r\n    height: 100%;\r\n    top: 0%;\r\n}\r\n\r\n.exceptionCell .lblCFE {\r\n    color: #ffffff;\r\n    top: 10%;\r\n    left: 5%;\r\n    z-index: 2;\r\n    font-weight: bold;\r\n}\r\n\r\n.exceptionCell .inpCONAGUA {\r\n\r\n    border-color: #002a33;\r\n    background-color: #00b7e1;\r\n    color: #ffffff;\r\n    height: 100%;\r\n    top: 0%;\r\n}\r\n\r\n.exceptionCell .lblCONAGUA {\r\n    color: #ffffff;\r\n    top: 10%;\r\n    left: 5%;\r\n    z-index: 2;\r\n    font-weight: bold;\r\n}\r\n\r\n.exceptionCell input {\r\n    border-color: #330015;\r\n    background-color: #9e0143;\r\n    color: #fdfdfd;\r\n    height: 100%;\r\n    top: 0%;\r\n}\r\n\r\n.exceptionCell label {\r\n    color: #ffffff;\r\n    top: 10%;\r\n    left: 5%;\r\n    z-index: 2;\r\n    /* font-weight: bold; */\r\n    word-break: break-all;\r\n    word-wrap: anywhere;\r\n    white-space: wrap;\r\n}\r\n\r\n\r\n/************************Horizontal Movil*************************/\r\n@media (min-width: 500px) and (max-width: 900px) {}\r\n\r\n/************************Movil*************************/\r\n@media (max-width: 500px) {\r\n    .labelData {\r\n        font-size: var(--font-size-small) !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
